import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const TabletInteractionIcon = memo(({ className, fontSize = 120 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="127"
    height="118"
    viewBox="0 0 127 118"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fontSize, fill: 'none' }}
  >
    <path
      d="M126.345 95.1429C126.345 93.1837 125.553 91.3469 124.15 89.9388L105.679 71.3877C104.033 69.7347 101.411 69.551 99.6434 71.0816C97.7535 72.7347 97.6926 75.6735 99.4605 77.3877L96.4733 74.3877C94.8273 72.7347 92.2059 72.551 90.438 74.0816C88.5481 75.7347 88.4872 78.6735 90.2551 80.3878L86.9631 77.0816C85.5 75.6122 83.1834 75.3061 81.4765 76.4082V10.4082C81.4765 7.34694 78.977 4.83673 75.9288 4.83673H11.1253C8.07719 4.83673 5.57771 7.34694 5.57771 10.4082V95.8163C5.57771 98.8775 8.07719 101.388 11.1253 101.388H75.9898C77.6358 101.388 78.4893 101.204 79.5256 100.102L80.0134 94.6531L81.7813 96.4286L90.499 105.184C90.9257 105.612 91.1695 106.163 91.0476 106.776C90.9257 107.633 90.3161 108.245 89.4626 108.367L70.8689 111.306C68.5523 111.612 66.9063 113.633 66.9063 115.959C66.9063 116.939 67.7598 117.735 68.7352 117.735H103.728C108.178 117.735 112.385 115.959 115.555 112.837L121.407 106.959C124.638 103.837 126.345 99.6122 126.345 95.1429ZM80.0134 94.7143L81.2326 95.9388L80.0134 94.7143Z"
      fill="#F1CAA4"
    />
    <path
      d="M56.8475 78C53.6164 74.7551 53.4335 69.6122 56.3598 66.2449C57.9448 64.4694 60.0785 63.4286 62.3951 63.3673C62.517 63.3673 62.6389 63.3673 62.7609 63.3673C64.9555 63.3673 67.0892 64.2857 68.6742 65.8776L70.747 67.9592C71.9053 69.1224 73.917 68.3265 73.917 66.6735V18.9184C73.917 16.898 72.2711 15.1837 70.1983 15.1837H16.9168C14.905 15.1837 13.1981 16.8367 13.1981 18.9184V82.5918C13.1981 84.6122 14.8441 86.3265 16.9168 86.3265H60.6272C62.2732 86.3265 63.0657 84.3061 61.9074 83.1429L56.8475 78Z"
      fill="#E8EFEA"
    />
    <path
      d="M40.8142 94.4082C42.2283 94.4082 43.3747 93.2569 43.3747 91.8367C43.3747 90.4166 42.2283 89.2653 40.8142 89.2653C39.4001 89.2653 38.2538 90.4166 38.2538 91.8367C38.2538 93.2569 39.4001 94.4082 40.8142 94.4082Z"
      fill="#E8EFEA"
    />
    <path
      d="M39.8998 92.5714C40.8088 92.5714 41.5458 91.8313 41.5458 90.9184C41.5458 90.0054 40.8088 89.2653 39.8998 89.2653C38.9907 89.2653 38.2538 90.0054 38.2538 90.9184C38.2538 91.8313 38.9907 92.5714 39.8998 92.5714Z"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.5139 92.8776L59.7737 75.0612C58.1277 73.4082 57.9448 70.7755 59.4689 69C61.1149 67.102 64.0411 67.0408 65.748 68.8163L77.0871 80.2041C75.3192 78.4286 75.3802 75.551 77.27 73.898C78.977 72.3673 81.6593 72.551 83.3053 74.2041L86.5973 77.5102C84.8294 75.7347 84.8904 72.8571 86.7802 71.2041C88.4872 69.6735 91.1696 69.8571 92.8156 71.5102L95.8027 74.5102C94.0348 72.7347 94.0958 69.8571 95.9856 68.2041C97.6926 66.6735 100.375 66.8571 102.021 68.5102L120.493 87.0612C121.895 88.4694 122.687 90.3061 122.687 92.2653C122.687 92.2653 122.687 92.2653 122.687 92.3265C122.687 96.7959 120.98 101.02 117.81 104.143L111.958 110.02C108.849 113.143 104.581 114.918 100.131 114.918H65.1384C64.163 114.918 63.3095 114.122 63.3095 113.143C63.2486 110.816 64.9555 108.857 67.2721 108.49L85.8658 105.551C86.6583 105.429 87.3289 104.755 87.4508 103.959C87.5118 103.347 87.2679 102.796 86.9021 102.367L78.1845 93.6122L76.4165 91.8367L64.4069 79.7755"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1478 43.4082V54"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.5126 43.4082V54"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.5126 48.6735H20.1478"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.4955 54V43.4082"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.8603 43.4082L48.4955 48.6735L53.8603 54"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.0463 54V43.4082L44.411 54V43.4082"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.5971 43.4082V51.3061C29.5971 52.7755 30.8163 54 32.2794 54C33.7425 54 34.9618 52.7755 34.9618 51.3061V43.4082"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M57.9448 54.1837H60.6272C62.0903 54.1837 63.3095 52.9592 63.3095 51.4898C63.3095 50.0204 62.0903 48.7959 60.6272 48.7959C59.1641 48.7959 57.9448 47.5714 57.9448 46.102C57.9448 44.6326 59.1641 43.4082 60.6272 43.4082H62.3951"
      stroke="#226937"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M77.8187 68.9388V7.40816C77.8187 4.34694 75.3192 1.83673 72.2711 1.83673H7.46756C4.41941 1.83673 1.91994 4.34694 1.91994 7.40816V92.8163C1.91994 95.8776 4.41941 98.3878 7.46756 98.3878H72.332C73.978 98.3878 74.8315 98.2041 75.8679 97.1021"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M60.5052 82.5918H11.3692C10.3328 82.5918 9.5403 81.7347 9.5403 80.7551V13.4082C9.5403 12.3673 10.3938 11.5714 11.3692 11.5714H68.4304C69.4668 11.5714 70.2593 12.4286 70.2593 13.4082V67.4694"
      stroke="#EA7200"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
